import { ReportBAVisitorListComponent } from './report-visitor.component';
export default ReportBAVisitorListComponent;
